import React from 'react';
import { useTranslation } from 'react-i18next';
import oveitLogo from '../../../assets/common/oveit-logo.svg';
import { useSelector } from 'react-redux';
import { selectVendorData } from 'store/vendorSlice/selectors';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';
import { isRenderedInsideEmbed } from 'utils/isRenderedInsideEmbed';

const Footer: React.FC<{}> = () => {
  const { t } = useTranslation();
  const { features } = useSelector(selectVendorData);

  if (features?.hideFooter && isRenderedInsideEmbed) {
    return null;
  }

  return (
    <footer className="flex flex-col items-center justify-center gap-1 py-2">
      {features?.hideFooter ? null : (
        <a
          className="flex items-center gap-2 group"
          href={`${process.env.REACT_APP_OVEIT_LINK}/sell-tickets/`}
          target="_blank"
        >
          <span className="p1-medium group-hover:underline">
            {t('footer.footer_motto')}
          </span>
          <img src={oveitLogo} alt="Oveit logo" />
        </a>
      )}
      {isRenderedInsideEmbed ? null : <LanguageSwitcher />}
    </footer>
  );
};

export default Footer;
